/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data, shop) {
  const navigate = useNavigate()

  const [tables, setTables] = useState([])

  useEffect(() => {
    setTables(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>عنوان</th>
            <th>کاربر</th>
            <th>بخش</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {tables ? tables.map(item => 
              <tr key={item._id}>
              <td>{item.subject}</td>
              <td>{item.user[0].name}</td>
              <td>{item.part}</td>
              <td style={item.status ? { color: '#198524' } : { color: '#fd3a50' }}>{item.status ? 'بررسی شده' : 'بررسی نشده'}</td>
              <td>
                <button onClick={() => navigate(`/supports/details/${item._id}`)}>مشاهده</button>
              </td>
            </tr> ) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
